export default "__VITE_ASSET__DCqmNhpG__"